import { createFilledIcon } from '@ps/ds/icons/helpers/createFilledIcon'

export const CircleCheck = createFilledIcon('CircleCheck', [
  [
    'circle',
    {
      cx: '11.875',
      cy: '11.85',
      r: '10.875',
      stroke: 'none',
      key: 'CircleCheck-0',
    },
  ],
  [
    'path',
    {
      d: 'M14.3809 9.3805C14.7226 9.0388 15.2774 9.0388 15.6191 9.3805C15.9608 9.72221 15.9608 10.2771 15.6191 10.6188L11.6192 14.6188C11.2775 14.9605 10.7226 14.9605 10.3809 14.6188L8.3809 12.6188C8.03919 12.2771 8.03919 11.7222 8.3809 11.3805C8.7226 11.0388 9.27747 11.0388 9.61918 11.3805L11 12.7614L14.3809 9.3805Z',
      fill: 'white',
      stroke: 'none',
      key: 'CircleCheck-1',
    },
  ],
])

CircleCheck.displayName = 'CircleCheck'
